import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["actionButton"];

  declare actionButtonTargets : HTMLInputElement[];

  disableActionButtons() {
    this.actionButtonTargets.forEach((button: HTMLInputElement) => {
      button.disabled = true;
    });
  }
}
